import { FaHistory, FaTree, FaLandmark, FaHeart } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaHistory />,
        title: 'counter.historyYears',
        count: '215',
    },
    {
        id: 2,
        icon: <FaTree />,
        title: 'counter.historicTrees',
        count: '150',
    },
    {
        id: 3,
        icon: <FaLandmark />,
        title: 'counter.buildYear',
        count: '1850',
    },
    {
        id: 4,
        icon: <FaHeart />,
        title: 'counter.supporters',
        count: '500',
    },
];

export default counter;